import { render, staticRenderFns } from "./ZxFawuContractTable.vue?vue&type=template&id=534b084c&scoped=true&"
import script from "./ZxFawuContractTable.vue?vue&type=script&lang=js&"
export * from "./ZxFawuContractTable.vue?vue&type=script&lang=js&"
import style0 from "./ZxFawuContractTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ZxFawuContractTable.vue?vue&type=style&index=1&id=534b084c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b084c",
  null
  
)

export default component.exports